module.exports = __webpack_public_path__ + "img/w3_chevron_down_grey.edcaeb67.png";